module.exports = __webpack_public_path__ + "img/GrabarMensaje.ec4b3a4e.png";